import * as moment from 'moment';

import { FxExecutionsReportTypeEnum, ReportFxExecutionColumnNames } from '@spa/api';

import {OnlyDigitsValidator} from '@spa/validators';

import {ComponentTypesEnum, UnspecifiedKeysEnum} from '../../../app/shared/enums';
import {FilterControlInterface} from '../../../app/shared/interfaces';
import {ReportTableColumn, ReportTableConfigInterface} from '../../../app/shared/components';
import {
    AmountControl,
    AutocompleteControl,
    BaseControl,
    DatepickerControl,
    SelectControl
} from '../../../app/shared/classes';

export const PanelReportsFxExecutionsStorageId = 'PanelReportsFxExecutionsComponent';

export const PanelReportsFxExecutionsFilterControls = (): FilterControlInterface[] => {
    return [
        {
            name: ReportFxExecutionColumnNames.ReportTime,
            placeholder: 'Report time',
            controls: [
                new SelectControl({
                    name: ReportFxExecutionColumnNames.ReportTime,
                    value: 'false',
                    placeholder: 'Report time',
                    validators: [],
                    componentType: ComponentTypesEnum.Select,
                    options: [
                        {
                            label: 'Exchange time',
                            value: 'false'
                        },
                        {
                            label: 'UTC time',
                            value: 'true'
                        }
                    ],
                })
            ],
            shown: true,
            sortIndex: 1
        }, 
        {
            name: ReportFxExecutionColumnNames.Currency,
            placeholder: 'Currency',
            controls: [
                new SelectControl({
                    name: ReportFxExecutionColumnNames.Currency,
                    value: null,
                    placeholder: 'Currency',
                    validators:  [],
                    componentType: ComponentTypesEnum.Select,
                    options: [
                        {
                            label: 'All',
                            value: UnspecifiedKeysEnum.UnspecifiedCurrencyKey
                        }
                    ]
                }),
            ],
            shown: true,
            sortIndex: 2
        },
        {
            name: ReportFxExecutionColumnNames.Type,
            placeholder: 'Type',
            controls: [
                new SelectControl({
                    name: ReportFxExecutionColumnNames.Type,
                    value: UnspecifiedKeysEnum.UnspecifiedExecutionTypeKey,
                    placeholder: 'Type',
                    validators: [],
                    componentType: ComponentTypesEnum.Select,
                    options: [
                        {
                            label: 'All',
                            value: UnspecifiedKeysEnum.UnspecifiedExecutionTypeKey
                        },
                        {
                            label: 'Buy',
                            value: FxExecutionsReportTypeEnum.Buy
                        },
                        {
                            label: 'Sell',
                            value: FxExecutionsReportTypeEnum.Sell
                        }
                    ],
                })
            ],
            shown: true,
            sortIndex: 3
        },
        {
            name: ReportFxExecutionColumnNames.Rate,
            placeholder: 'Rate',
            controls: [
                new AmountControl({
                    name: ReportFxExecutionColumnNames.RateFrom,
                    value: null,
                    placeholder: 'Rate From',
                    validators: [],
                    componentType: ComponentTypesEnum.AmountInput,
                    currency: null,
                    sortIndex: 1
                }),
                new AmountControl({
                    name: ReportFxExecutionColumnNames.RateTo,
                    value: null,
                    placeholder: 'Rate To',
                    validators: [],
                    componentType: ComponentTypesEnum.AmountInput,
                    currency: null,
                    sortIndex: 2
                }),
            ],
            shown: true,
            sortIndex: 4
        },
        {
            name: ReportFxExecutionColumnNames.Quantity,
            placeholder: 'Quantity',
            controls: [
                new BaseControl({
                    name: ReportFxExecutionColumnNames.QuantityFrom,
                    value: null,
                    placeholder: 'Quantity From',
                    validators: [OnlyDigitsValidator()],
                    componentType: ComponentTypesEnum.Text,
                    sortIndex: 1
                }),
                new BaseControl({
                    name: ReportFxExecutionColumnNames.QuantityTo,
                    value: null,
                    placeholder: 'Quantity То',
                    validators: [OnlyDigitsValidator()],
                    componentType: ComponentTypesEnum.Text,
                    sortIndex: 2
                }),
            ],
            shown: true,
            sortIndex: 5
        }, 
        {
            name: ReportFxExecutionColumnNames.OrderId,
            placeholder: 'Order ID',
            controls: [
                new BaseControl({
                    name: ReportFxExecutionColumnNames.OrderId,
                    value: null,
                    placeholder: 'Order ID',
                    validators: [],
                    componentType: ComponentTypesEnum.Text,
                })
            ],
            shown: true,
            sortIndex: 6
        },
        {
            name: ReportFxExecutionColumnNames.Group,
            placeholder: 'Group',
            controls: [
                new AutocompleteControl({
                    name: ReportFxExecutionColumnNames.Group,
                    value: UnspecifiedKeysEnum.UnspecifiedAccountsKey,
                    placeholder: 'Group',
                    validators:  [],
                    componentType: ComponentTypesEnum.Autocomplete,
                    options: [
                        {
                            label: 'All',
                            value: UnspecifiedKeysEnum.UnspecifiedAccountsKey
                        }
                    ]
                })
            ],
            shown: true,
            sortIndex: 7
        },
        {
            name: ReportFxExecutionColumnNames.AccountReferenceId,
            placeholder: 'Account',
            controls: [
                new AutocompleteControl({
                    name: ReportFxExecutionColumnNames.AccountReferenceId,
                    value: null,
                    placeholder: 'Account',
                    validators: [],
                    componentType: ComponentTypesEnum.Autocomplete,
                    options: [],
                    grouped: false
                })
            ],
            shown: true,
            sortIndex: 8
        },
        {
            name: ReportFxExecutionColumnNames.Date,
            placeholder: 'Date',
            controls: [
                new DatepickerControl({
                    name: ReportFxExecutionColumnNames.FromDate,
                    value: null,
                    placeholder: 'Date From',
                    maxDate: moment().format('YYYY-MM-DD'),
                    validators: [],
                    componentType: ComponentTypesEnum.Datepicker
                }),
                new DatepickerControl({
                    name: ReportFxExecutionColumnNames.ToDate,
                    value: null,
                    placeholder: 'Date to',
                    maxDate: moment().format('YYYY-MM-DD'),
                    validators: [],
                    componentType: ComponentTypesEnum.Datepicker
                })
            ],
            shown: true,
            sortIndex: 9
        }
    ];
};

export const PanelReportsFxExecutionsDataTableConfig: ReportTableConfigInterface = {
    rows: [],
    columns: [
        new ReportTableColumn({ label: 'DATE', selector: ReportFxExecutionColumnNames.Date}),
        new ReportTableColumn({ label: 'ACCOUNT', selector: ReportFxExecutionColumnNames.Account}),
        new ReportTableColumn({ label: 'CCY', selector: ReportFxExecutionColumnNames.Currency }),
        new ReportTableColumn({ label: 'TYPE', selector: ReportFxExecutionColumnNames.Type}), 
        new ReportTableColumn({ label: 'QTY', selector: ReportFxExecutionColumnNames.Quantity, shifted: true}),
        new ReportTableColumn({ label: 'RATE', selector: ReportFxExecutionColumnNames.Rate, shifted: true}),
        new ReportTableColumn({ label: 'AMNT', selector: ReportFxExecutionColumnNames.Amount, shifted: true}),
        new ReportTableColumn({ label: 'SETTLE CCY', selector: ReportFxExecutionColumnNames.SettlementCurrency}), 
        new ReportTableColumn({ label: 'COMM', selector: ReportFxExecutionColumnNames.Commission, shifted: true}),
        new ReportTableColumn({ label: 'COMM CCY', selector: ReportFxExecutionColumnNames.CommissionCurrency}),
        new ReportTableColumn({ label: 'ORDER ID', selector: ReportFxExecutionColumnNames.OrderId}),
        new ReportTableColumn({ label: 'FILL ID', selector: ReportFxExecutionColumnNames.FillId}), 
    ],
    hiddenColumnIds: [],
    actionMenu: false,
    disableColumnsOptions: true
};
